import gql from 'graphql-tag';

export const VALIDATE_LOCATIONS = gql`
  query checkLocationAvailability(
    $providerId: Float!
    $locationType: String!
    $startTime: String!
    $endTime: String!
    $selectedClinicId: Float!
  ) {
    checkLocationAvailability(
      providerId: $providerId
      locationType: $locationType
      startTime: $startTime
      endTime: $endTime
      selectedClinicId: $selectedClinicId
    ) {
      alertMessage
    }
  }
`;

export const VALIDATE_MEAL_WAIVER = gql`
  query checkMealWaiverAlert(
    $providerId: Float!
    $startTime: String!
    $endTime: String!
    $eventId: Float
  ) {
    checkMealWaiverAlert(
      providerId: $providerId
      startTime: $startTime
      endTime: $endTime
      eventId: $eventId
    ) {
      alertMessage
      hasMealWaiver
      showAlert
      totalConsecutiveHours
    }
  }
`;
